export const safeSessionStorage = (() => {
    try {
        return sessionStorage; //users can disable this; causing client-side crashes
    } catch {
        return null;
    }
})();

